import tippy from 'tippy.js';

function decodePortraitImage(portraitClass) {
  const probe = document.createElement('div');
  probe.className = portraitClass;
  probe.style.position = 'absolute';
  probe.style.width = '0';
  probe.style.height = '0';
  document.body.appendChild(probe);
  const backgroundImage = globalThis.getComputedStyle(probe).backgroundImage;
  document.body.removeChild(probe);
  const source = backgroundImage.match(/url\(["']?(.*?)["']?\)/);
  if (!source) {
    return;
  }
  const image = new Image();
  image.src = source[1];
  if (image.decode) {
    image.decode().catch(error => {
      console.warn(`Could not decode portrait image ${source[1]}`, error);
    });
  }
}

$(document).ready(function () {
  const tooltipList = tippy('.portrait-tooltip', {
    content(reference) {
      const id = reference.getAttribute('data-template');
      const template = document.getElementById(id);
      template.style.display = 'block';
      return template;
    },
    placement: 'top',
    arrow: false,
    interactive: true,
    delay: [400, null],
    duration: 700,
    popperOptions: {
      modifiers: [
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['left', 'right'],
          },
        },
      ],
    },
  });

  const centerTooltip = tippy('.center-tooltip', {
    content(reference) {
      const id = reference.getAttribute('data-template');
      const template = document.getElementById(id);
      template.style.display = 'block';
      return template;
    },
    placement: 'top',
    arrow: false,
    interactive: true,
    duration: 700,
    onShow(instance) {
      instance.popper
        .querySelector('#principals-close-tippy')
        .addEventListener('click', () => {
          instance.hide();
        });
    },
    onHide(instance) {
      instance.popper
        .querySelector('#principals-close-tippy')
        .removeEventListener('click', () => {
          instance.hide();
        });
    },
    popperOptions: {
      modifiers: [
        {
          name: 'flip',
          options: {
            fallbackPlacements: [],
          },
        },
      ],
    },
    trigger: 'click',
  });

  tooltipList.forEach(tooltip => {
    let content = tooltip.props.content;
    const templateId = content.id.split('-')[0];
    const portraitColored = `${templateId}-colored`;
    const portraitLarge = `${templateId}-large`;
    decodePortraitImage(portraitColored);
    decodePortraitImage(portraitLarge);
    const teamButton = $(content).find('.portrait-buttons > .button.team');
    const bioButton = $(content).find('.portrait-buttons > .button.bio');
    const quoteButton = $(content).find('.portrait-buttons > .button.quote');
    const nextButton = $(content).find('.portrait-buttons > .bio-next');
    const previousButton = $(content).find('.portrait-buttons > .bio-previous');
    const isMultiPage = nextButton.length;
    let bioPage = 0;
    if (isMultiPage) {
      const description1 = $(content).find('.portrait-description').html();
      const description2 = $(content).find('.description-2').html();
      bioPage = 1;
      nextButton.click(() => {
        $(content).find('.portrait-description').html(description2);
        nextButton.addClass('hidden');
        previousButton.removeClass('hidden');
        bioPage = 2;
      });
      previousButton.click(() => {
        $(content).find('.portrait-description').html(description1);
        nextButton.removeClass('hidden');
        previousButton.addClass('hidden');
        bioPage = 1;
      });
    }

    teamButton.click(() => {
      $(content).find('.portrait-description').removeClass('hidden');
      $(content).find('.portrait-description').addClass('hidden-text');
      $(content).find('.portrait-quote').addClass('hidden');
      $(content).addClass(portraitColored);
      $(content).removeClass('portrait-blank');

      $(teamButton).addClass('button-selected');
      $(bioButton).removeClass('button-selected');
      $(quoteButton).removeClass('button-selected');

      $(teamButton).find('.icon-select').removeClass('hidden');
      $(teamButton).find('.icon-unselect').addClass('hidden');
      $(bioButton).find('.icon-select').addClass('hidden');
      $(bioButton).find('.icon-unselect').removeClass('hidden');
      $(quoteButton).find('.icon-select').addClass('hidden');
      $(quoteButton).find('.icon-unselect').removeClass('hidden');

      if (isMultiPage) {
        bioButton.removeClass('hidden');
        nextButton.addClass('hidden');
        previousButton.addClass('hidden');
      }
    });

    bioButton.click(() => {
      $(content)
        .find('.portrait-description')
        .removeClass('hidden hidden-text');
      $(content).find('.portrait-quote').addClass('hidden');
      $(content).removeClass(portraitColored);
      $(content).addClass('portrait-blank');

      $(teamButton).removeClass('button-selected');
      $(bioButton).addClass('button-selected');
      $(quoteButton).removeClass('button-selected');

      $(teamButton).find('.icon-select').addClass('hidden');
      $(teamButton).find('.icon-unselect').removeClass('hidden');
      $(bioButton).find('.icon-select').removeClass('hidden');
      $(bioButton).find('.icon-unselect').addClass('hidden');
      $(quoteButton).find('.icon-select').addClass('hidden');
      $(quoteButton).find('.icon-unselect').removeClass('hidden');

      if (isMultiPage) {
        if (bioPage === 1) {
          bioButton.addClass('hidden');
          nextButton.removeClass('hidden');
        } else if (bioPage === 2) {
          bioButton.addClass('hidden');
          previousButton.removeClass('hidden');
        }
      }
    });

    quoteButton.click(() => {
      $(content).find('.portrait-description').addClass('hidden');
      $(content).find('.portrait-quote').removeClass('hidden hidden-text');
      $(content).removeClass(portraitColored);
      $(content).addClass('portrait-blank');

      $(teamButton).removeClass('button-selected');
      $(bioButton).removeClass('button-selected');
      $(quoteButton).addClass('button-selected');

      $(teamButton).find('.icon-select').addClass('hidden');
      $(teamButton).find('.icon-unselect').removeClass('hidden');
      $(bioButton).find('.icon-select').addClass('hidden');
      $(bioButton).find('.icon-unselect').removeClass('hidden');
      $(quoteButton).find('.icon-select').removeClass('hidden');
      $(quoteButton).find('.icon-unselect').addClass('hidden');

      if (isMultiPage) {
        bioButton.removeClass('hidden');
        nextButton.addClass('hidden');
        previousButton.addClass('hidden');
      }
    });

    $(content).mouseenter(() => {
      $(content).children().toggleClass('hidden-text shown-text');
      $(content).toggleClass(
        `large-portrait ${portraitLarge} ${portraitColored} hidden-text shown-text`,
      );
    });
    $(content).mouseleave(() => {
      $(content).children().toggleClass('hidden-text shown-text');
      $(content).toggleClass(
        `large-portrait ${portraitLarge} ${portraitColored} hidden-text shown-text`,
      );
    });
  });

  const principalsOpenButton = $('#principals-open');
  const principalsCloseButton = $('#principals-close');

  principalsOpenButton.click(() => {
    $('.principals-team-text').show(500);
    $('.principals-close-button').show(500);
    $('.about-team-center').css('grid-row-gap', '2em');
  });

  principalsCloseButton.click(() => {
    $('.principals-team-text').hide(500);
    $('.principals-close-button').hide(500);
    $('.about-team-center').css('grid-row-gap', '0');
  });
});
